import elements from "@/components/widgets/image_image2/elements.js";
import {getNodeById} from "@/components/common/controlBar/controlBarDialog/metaComponent/worker.js";
import {
  getMetaComponentByCustomKey, getValueByCustomName,
  modifyValueByCustomName
} from "@/components/common/controlBar/controlBarDialog/metaComponent/utils.js";
import {unitTransformSimplify} from "@/components/common/controlBar/controlBarDialog/metaComponent/unitTransform.js";

function getDomOfNode(node) {
  var dom = document.querySelector(`.${node.id}`)
  return dom
}
function setreferenceDomStyle({left,top, width, height}){
  return `
    position: fixed;
    left: ${left}px;
     top: ${top}px;
    width: ${width}px;
     height: ${height}px;
     outline: 2px solid purple;
     z-index: 1000;
     `
}

function setClipDomStyle({left,top, width, height}){
  return `
    left: ${left}px;
    top: ${top}px;
    width: ${width}px;
    height: ${height}px;
    outline: rgb(227, 235, 227) dashed 2px;
    position: absolute;
    z-index: 5;
    `
}

export function setClipStatus(node){
  var domOfImg = getDomOfNode(node)
  var {left,top, width, height} = domOfImg.getBoundingClientRect()
  var url = node.originImgOfClip || node.data.attribute.img_url



  var style = document.createElement('style')
  style.type = 'text/css'
  style.className = 'tempStyle'
  style.innerText = `.realImgHidden{visibility: hidden !important;}`
  document.body.append(style)
  domOfImg.classList.add('realImgHidden')

  var nodeId = node.id


  var dom = document.querySelector(`.${nodeId} img`)




  var clipMask = document.createElement("div");
  clipMask.className = 'clipMask'
  clipMask.style = `
    width: 100%;
    height: 100%;
    position: fixed;
    top:0px;
    left: 0px;
    background: #0000ff2e;
    z-index: 10000;
  `
  clipMask.addEventListener('wheel', function(event) {
    event.preventDefault();
  });
  document.body.appendChild(clipMask)

  var referenceDom = document.createElement("div");
  referenceDom.className = 'referenceDom'
  referenceDom.setAttribute('data-id', node.id)
  referenceDom.style = setreferenceDomStyle({
    left,
    top,
    width,
    height
  })
  clipMask.appendChild(referenceDom)



  getImageInfo(url).then((oImg)=>{
    getCanvasOfOriginImg(url,node.data.attribute.img_clip?.canvasOfOriginImg_scale || (()=>{
      var res = parseFloat(referenceDom.style.width) / oImg.width
      return res
    })(), dom).then((canvasOfOriginImg)=>{
      var node = getNodeById(nodeId)
      canvasOfOriginImg.style = setStyle({
        left: node.data.attribute.img_clip?.canvasOfOriginImg_x || 0,
        top: node.data.attribute.img_clip?.canvasOfOriginImg_y || 0
      })


      referenceDom.appendChild(canvasOfOriginImg)

      getClipBox(nodeId).then((clipBox)=>{
        clipBox.style = setClipDomStyle({
          left: 0,
          top: 0,
          width: node.data.attribute.img_clip?.clipBox_width || parseFloat(referenceDom.style.width),
          height: node.data.attribute.img_clip?.clipBox_height || parseFloat(referenceDom.style.height)
        })

        canvasOfOriginImg.after(clipBox)




        var clipCancelBtn = document.createElement('div')
        clipCancelBtn.className = 'clip-cancleBtn'
        clipCancelBtn.style = 'position: absolute;\n z-index:6; width: 32px;  top: 0px;\n    left: '+ clipBox.offsetWidth +'px;\n    background: #00000078;\n    padding: 4px;\n    border-radius: 2px;\n    color: white;'
        clipCancelBtn.innerHTML = '取消'
        clipCancelBtn.onclick = (ev)=>{
          clipBox.close(ev)
        }
        clipBox.after(clipCancelBtn)


        var clipOkBtn = document.createElement('div')
        clipOkBtn.className = 'clip-okBtn'
        clipOkBtn.style = 'position: absolute;\n  z-index:6; width: 32px; top: 30px;\n    left: '+ clipBox.offsetWidth +'px;\n    background: #00000078;\n    padding: 4px;\n    border-radius: 2px;\n    color: white;'
        clipOkBtn.innerHTML = '确定'
        clipOkBtn.onclick = (ev)=>{
          clipBox.ok(ev)
        }
        clipBox.after(clipOkBtn)


        var id = document.querySelector('.referenceDom').getAttribute('data-id')
        var imgNode = getNodeById(id)
        if(imgNode.originImgOfClip){

          var clipOriginImgBtn = document.createElement('div')
          clipOriginImgBtn.className = 'clip-originImgBtn'
          clipOriginImgBtn.style = 'position: absolute;\n    z-index:6;  width: 58px;      top: 60px;\n            left: '+ clipBox.offsetWidth +'px;\n            background: #00000078;\n            padding: 4px;\n            border-radius: 2px;\n            color: white;'
          clipOriginImgBtn.innerHTML = '使用原图'

          clipOriginImgBtn.onclick = (ev)=>{
            clipBox.originImg(ev)
          }


          clipBox.after(clipOriginImgBtn)
        }

      })

    })
  })



}

function getClipBox(nodeId){
  var dom = document.querySelector(`.${nodeId} img`)
  var canvasOfOriginImg = document.querySelector(`.canvasOfOriginImg`)
  return new Promise((resolve)=>{
    var clipBox = document.querySelector(`.${nodeId} .clipBox`)
    if(!clipBox){
      clipBox = document.createElement('div')
      clipBox.className = "clipBox"
      clipBox = addDragFunction({
        dragedDom: clipBox,
        opacity: 1,
        resizeble: true,
        onmousedown: ()=>{
          clipBox._tempLeft = parseFloat(getComputedStyle(clipBox)['left'])
          clipBox._tempTop = parseFloat(getComputedStyle(clipBox)['top'])
          clipBox._tempWidth = parseFloat(getComputedStyle(clipBox)['width'])
          clipBox._tempHeight = parseFloat(getComputedStyle(clipBox)['height'])


          canvasOfOriginImg._tempLeft = parseFloat(getComputedStyle(canvasOfOriginImg)['left'])
          canvasOfOriginImg._tempTop = parseFloat(getComputedStyle(canvasOfOriginImg)['top'])
        },
        limitFn: (dragedDom,type)=>{

          var minLeft = parseFloat(clipBox.style.left) - (
              (clipBox.getBoundingClientRect().left) -
              (canvasOfOriginImg.getBoundingClientRect().left)
          )
          var minTop = parseFloat(clipBox.style.top) - (
              (clipBox.getBoundingClientRect().top) -
              (canvasOfOriginImg.getBoundingClientRect().top)
          )


          var maxLeft = (()=>{
            if(type === 'clipBox-move'){
              return parseFloat(clipBox.style.left) + (
                  canvasOfOriginImg.getBoundingClientRect().width -
                  clipBox.getBoundingClientRect().width -
                  (clipBox.getBoundingClientRect().left - canvasOfOriginImg.getBoundingClientRect().left)
              )
            }else{
              return parseFloat(clipBox.style.left) + (
                  canvasOfOriginImg.getBoundingClientRect().width -
                  (clipBox.getBoundingClientRect().left - canvasOfOriginImg.getBoundingClientRect().left)
              ) - 10
            }
          })()

          var maxTop = (()=>{
            if(type === 'clipBox-move'){
              return parseFloat(clipBox.style.top) + (
                  canvasOfOriginImg.getBoundingClientRect().height -
                  clipBox.getBoundingClientRect().height -
                  (clipBox.getBoundingClientRect().top - canvasOfOriginImg.getBoundingClientRect().top)
              )
            }else{
              return parseFloat(clipBox.style.top) + (
                  canvasOfOriginImg.getBoundingClientRect().height -
                  (clipBox.getBoundingClientRect().top - canvasOfOriginImg.getBoundingClientRect().top)
              ) - 10
            }

          })()

          var minWidth = 10
          var maxWidth = canvasOfOriginImg.getBoundingClientRect().width - (
              clipBox.getBoundingClientRect().left - canvasOfOriginImg.getBoundingClientRect().left
          )
          var minHeight = 10
          var maxHeight = canvasOfOriginImg.getBoundingClientRect().height - (
              clipBox.getBoundingClientRect().top - canvasOfOriginImg.getBoundingClientRect().top
          )
          return [
            minLeft,
            minTop,
            maxLeft,
            maxTop,
            minWidth,
            maxWidth,
            minHeight,
            maxHeight
          ]
        }
      })
      resolve(clipBox)
    }else{
      resolve(clipBox)
    }
  })
}




function setStyle({left, top,  opacity}){
  var str
  str =  `
      position:absolute;
      left: ${left}px;
      top:${top}px;
      opacity: 0.7;
      z-index: 3;
      outline: 3px solid blue;
    `
  return str
}

function addDragFunction({
                           dragedDom,
                           limitFn,

                           resizeble = false,
                           onmousedown = ()=>{},
  scaleble = false,
  opacity = false
                         }){





  if(resizeble){
    dragedDom.innerHTML += `
          <div class="leftTop" style="width: 8px;height: 8px; position: absolute;top:0px;left: 0px;background: #3eddd76b;"></div>
          <div class="rightTop" style="width: 8px;height: 8px; position: absolute;top:0px;right: 0px;background: #3eddd76b;"></div>
          <div class="leftBottom" style="width: 8px;height: 8px; position: absolute;bottom:0px;left: 0px;background: #3eddd76b;"></div>
          <div class="rightBottom" style="width: 8px;height: 8px; position: absolute;bottom:0px;right: 0px;background: #3eddd76b;"></div>

          <div class="topCenter" style="width: 8px;height: 8px; position: absolute;top:0px;left: 50%;transform: translateX(-50%);background: #3eddd76b;"></div>
          <div class="bottomCenter" style="width: 8px;height: 8px; position: absolute;bottom:0px;left: 50%;transform: translateX(-50%);background: #3eddd76b;"></div>
          <div class="leftCenter" style="width: 8px;height: 8px; position: absolute;top:50%;left: 0px;transform: translateY(-50%);background: #3eddd76b;"></div>
          <div class="rightCenter" style="width: 8px;height: 8px; position: absolute;top:50%;right: 0px;transform: translateY(-50%);background: #3eddd76b;"></div>
        `

  }



  if(scaleble){
    var clipMask = document.querySelector('.clipMask')
    clipMask.addEventListener('wheel', function(event) {
      event.preventDefault();
      if (event.deltaY < 0) {
        dragedDom.scale = dragedDom.scale + 0.01
        // if(dragedDom.scale > 1){
        //   dragedDom.scale = 1
        // }
        dragedDom.render('extra')

      } else if (event.deltaY > 0) {
        dragedDom.scale = dragedDom.scale - 0.01
        if(dragedDom.scale <= 0){
          dragedDom.scale = 0.01
        }
        dragedDom.render('shink')
      }

      dragedDom.limitArr = limitFn(dragedDom)
    });
  }




  dragedDom.onmousemoveFn = (ev)=>{
    var [
      minLeft,
      minTop,
      maxLeft,
      maxTop,
      minWidth,
      maxWidth,
      minHeight,
      maxHeight
    ] = dragedDom.limitArr

    var distanceX = ev.clientX - dragedDom.mousedownX
    var distanceY = ev.clientY - dragedDom.mousedownY






    if(dragedDom.dragMode.startsWith('resize')){
      var dragMode = dragedDom.dragMode
      if(dragMode === 'resize-leftTop'){
        dragedDom.style = setClipDomStyle({
          left: dragedDom.computeLeft(minLeft, maxLeft, distanceX),
          top: dragedDom.computeTop(minTop, maxTop, distanceY),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX, 'oppsite'),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY, 'oppsite')
        })
      }else if(dragMode === 'resize-topCenter'){
        dragedDom.style = setClipDomStyle({
          left: parseInt(dragedDom.style.left),
          top: dragedDom.computeTop(minTop, maxTop, distanceY),
          width: parseInt(dragedDom.style.width),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY, 'oppsite')
        })
      }
      else if(dragMode === 'resize-rightTop'){
        dragedDom.style = setClipDomStyle({
          left: parseInt(dragedDom.style.left),
          top: dragedDom.computeTop(minTop, maxTop, distanceY),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY, 'oppsite')
        })
      }
      else if(dragMode === 'resize-rightCenter'){
        dragedDom.style = setClipDomStyle({
          left: parseInt(dragedDom.style.left),
          top: parseInt(dragedDom.style.top),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX),
          height: parseInt(dragedDom.style.height)
        })

      }
      else if(dragMode === 'resize-rightBottom'){
        dragedDom.style = setClipDomStyle({
          left: parseInt(dragedDom.style.left),
          top: parseInt(dragedDom.style.top),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY)
        })
      }
      else if(dragMode === 'resize-bottomCenter'){
        dragedDom.style = setClipDomStyle({
          left: parseInt(dragedDom.style.left),
          top: parseInt(dragedDom.style.top),
          width: parseInt(dragedDom.style.width),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY)
        })

      }
      else if(dragMode === 'resize-leftBottom'){
        dragedDom.style = setClipDomStyle({
          left: dragedDom.computeLeft(minLeft, maxLeft, distanceX),
          top: parseInt(dragedDom.style.top),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX, 'oppsite'),
          height: dragedDom.computeHeight(minHeight, maxHeight, distanceY)
        })
      }
      else if(dragMode === 'resize-leftCenter'){
        dragedDom.style = setClipDomStyle({
          left: dragedDom.computeLeft(minLeft, maxLeft, distanceX),
          top: parseInt(dragedDom.style.top),
          width: dragedDom.computeWidth(minWidth, maxWidth, distanceX, 'oppsite'),
          height: parseInt(dragedDom.style.height)
        })
      }


      dragedDom.limitArr = limitFn(dragedDom)

    }else{

      if(dragedDom.closest('.clipBox')){
        dragedDom.style = setClipDomStyle({
          left: dragedDom.computeLeft(minLeft, maxLeft, distanceX),
          top: dragedDom.computeTop(minTop, maxTop, distanceY),
          width: parseInt(dragedDom.style.width),
          height: parseInt(dragedDom.style.height)
        })
        dragedDom.limitArr = limitFn(dragedDom, 'clipBox-move')
      }else{
        dragedDom.style = setStyle({
          left: dragedDom.computeLeft(minLeft, maxLeft, distanceX),
          top: dragedDom.computeTop(minTop, maxTop, distanceY)
        })
      }


    }

    dragedDom.oldClientX = ev.clientX
    dragedDom.oldClientY = ev.clientY

  }

  dragedDom.isDragLeftConner = ()=>{
    return ['leftTop', 'leftCenter', 'leftBottom'].includes(dragedDom.dragMode.split('-')[1])
  }
  dragedDom.isDragTopConner = ()=>{
    return ['leftTop', 'topCenter', 'rightTop'].includes(dragedDom.dragMode.split('-')[1])
  }



  dragedDom.computeHeight = (minHeight, maxHeight, distanceY, type = 'positive')=>{
    var height
    if(type === 'positive'){
      height = dragedDom.startHeight + distanceY
    }else{
      height = dragedDom.startHeight - distanceY
    }


    if(height <= minHeight ){
      height = minHeight
    }
    if(height >= maxHeight ){
      height = maxHeight
    }
    return height
  }
  dragedDom.computeWidth = (minWidth, maxWidth, distanceX, type = 'positive')=>{
    var width
    if(type === 'positive'){
      width = dragedDom.startWidth + distanceX
    }else{
      width = dragedDom.startWidth - distanceX
    }

    if(width <= minWidth ){
      width = minWidth
    }
    if(width >= maxWidth ){
      width = maxWidth
    }
    return width
  }
  dragedDom.computeLeft = (minLeft, maxLeft, distanceX)=>{
    var left = dragedDom.startLeft + distanceX
    if(left <= minLeft ){
      left = minLeft
    }
    if(left >= maxLeft ){
      left = maxLeft
    }
    return left
  }
  dragedDom.computeTop = (minTop, maxTop, distanceY)=>{
    var top = dragedDom.startTop + distanceY
    if(top <= minTop ){
      top = minTop
    }
    if(top >= maxTop ){
      top = maxTop
    }
    return top
  }

  dragedDom.onmouseupFn = ()=>{
    document.removeEventListener('mousemove', dragedDom.onmousemoveFn)
    document.removeEventListener('mouseup', dragedDom.onmouseupFn)
  }

  dragedDom.close = (ev)=>{
    var id = ev.target.closest('.referenceDom').getAttribute('data-id')
    var node = getNodeById(id)

    var nodeDom = getDomOfNode(node)
    nodeDom.classList.remove('realImgHidden')

    document.querySelector('.clipMask').remove()




    document.removeEventListener('mousemove', dragedDom.onmousemoveFn)
    document.removeEventListener('mouseup', dragedDom.onmouseupFn)

  }
  dragedDom.originImg = async (ev)=>{

    var id = ev.target.closest('.referenceDom').getAttribute('data-id')
    var node = getNodeById(id)
    modifyValueByCustomName(node, 'img_clip', undefined)
    modifyValueByCustomName(
      node,
      'img_url',
      node.originImgOfClip
    )
    await parseNodesStyle()

    node.originImgOfClip = undefined;
    dragedDom.close(ev)
  }
  dragedDom.ok = (ev)=>{

    mm.loading(document.querySelector('.clipBox'))

    var id = ev.target.closest('.referenceDom').getAttribute('data-id')
    var node = getNodeById(id)

    var x = (document.querySelector('.clipBox').getBoundingClientRect().x - document.querySelector('.canvasOfOriginImg').getBoundingClientRect().x)
    var y = (document.querySelector('.clipBox').getBoundingClientRect().y - document.querySelector('.canvasOfOriginImg').getBoundingClientRect().y)
    var width = document.querySelector('.clipBox').getBoundingClientRect().width
    var height = document.querySelector('.clipBox').getBoundingClientRect().height




    clipAndUpload(node.data.attribute[`${elements.img}_url`],
      {x, y, width, height}
    ).then(async (url)=>{


      // modifyValueByCustomName(
      //   node,
      //   'self_marginLeft',
      //   unitTransformSimplify(
      //     'px',
      //     (()=>{
      //       let marginUnit = getValueByCustomName(node, 'self_marginUnit')
      //       return marginUnit
      //     })(),
      //     (()=>{
      //       var dom = getDomOfNode(node)
      //       let marginLeft = parseInt(getComputedStyle(dom).marginLeft) + (
      //           parseInt(document.querySelector('.clipBox').style.left)
      //       )
      //       return marginLeft
      //     })(),
      //     node,
      //     getMetaComponentByCustomKey('self_marginLeft', node.controllerModule)
      //   )
      // )
      // modifyValueByCustomName(
      //   node,
      //   'self_marginTop',
      //   unitTransformSimplify(
      //     'px',
      //     (()=>{
      //       let marginUnit = getValueByCustomName(node, 'self_marginUnit')
      //       return marginUnit
      //     })(),
      //     (()=>{
      //       var dom = getDomOfNode(node)
      //       let marginLeft = parseInt(getComputedStyle(dom).marginTop) + (
      //           parseInt(document.querySelector('.clipBox').style.top)
      //       )
      //       return marginLeft
      //     })(),
      //     node,
      //     getMetaComponentByCustomKey('self_marginTop', node.controllerModule)
      //   )
      // )
      //
      // modifyValueByCustomName(
      //   node,
      //   'self_width',
      //   unitTransformSimplify(
      //     'px',
      //     (()=>{
      //       let marginUnit = getValueByCustomName(node, 'self_widthUnit')
      //       return marginUnit
      //     })(),
      //     (()=>{
      //       let marginLeft = parseInt(document.querySelector('.clipBox').style.width)
      //       return marginLeft
      //     })(),
      //     node,
      //     getMetaComponentByCustomKey('self_width', node.controllerModule)
      //   )
      // )
      // modifyValueByCustomName(
      //   node,
      //   'self_height',
      //   unitTransformSimplify(
      //     'px',
      //     (()=>{
      //       let marginUnit = getValueByCustomName(node, 'self_heightUnit')
      //       return marginUnit
      //     })(),
      //     (()=>{
      //       let marginLeft = parseInt(document.querySelector('.clipBox').style.height)
      //       return marginLeft
      //     })(),
      //     node,
      //     getMetaComponentByCustomKey('self_height', node.controllerModule)
      //   )
      // )
      //



      if(!node.originImgOfClip){
        node.originImgOfClip = node.data.attribute[`img_url`];
      }

      modifyValueByCustomName(node, 'img_clip', {
        canvasOfOriginImg_x: - ( document.querySelector('.clipBox').getBoundingClientRect().x -  document.querySelector('.canvasOfOriginImg').getBoundingClientRect().x),
        canvasOfOriginImg_y: - ( document.querySelector('.clipBox').getBoundingClientRect().y -  document.querySelector('.canvasOfOriginImg').getBoundingClientRect().y),
        canvasOfOriginImg_scale: document.querySelector('.canvasOfOriginImg').scale,
        clipBox_width: parseInt(document.querySelector('.clipBox').style.width),
        clipBox_height: parseInt(document.querySelector('.clipBox').style.height),
      })
      modifyValueByCustomName(
        node,
        'img_url',
        url
      )
      await parseNodesStyle()

      dragedDom.close(ev)
    })





  }

  dragedDom.addEventListener('mousedown', (ev) => {

    dragedDom.limitArr = limitFn(dragedDom)

    dragedDom.dragMode = (()=>{
      var corners = ['leftTop', 'rightTop', 'leftBottom', 'rightBottom', 'topCenter', 'bottomCenter', 'leftCenter', 'rightCenter']
      if(corners.includes(ev.target.className)){
        return `resize-${ev.target.className}`
      }else{
        return 'move'
      }
    })()


    dragedDom.startLeft = parseInt(dragedDom.style.left)
    dragedDom.startTop = parseInt(dragedDom.style.top)
    dragedDom.startWidth = parseInt(dragedDom.style.width)
    dragedDom.startHeight = parseInt(dragedDom.style.height)

    dragedDom.mousedownX = ev.clientX
    dragedDom.mousedownY = ev.clientY

    document.removeEventListener('mousemove', dragedDom.onmousemoveFn)
    document.removeEventListener('mouseup', dragedDom.onmouseupFn)
    document.addEventListener('mousemove', dragedDom.onmousemoveFn)
    document.addEventListener('mouseup', dragedDom.onmouseupFn)


    onmousedown(dragedDom)

  }, false)
  return dragedDom
}

function getImageInfo(url){
  return new Promise((resolve)=>{
    let oImg = new Image();
    oImg.crossOrigin = "Anonymous";
    oImg.src = url;
    oImg.onload = function() {
      resolve(oImg)
    }
  })

}

function getCanvasOfOriginImg(url, scale){
  return new Promise((resolve)=>{
    var canvasOfOriginImg = document.querySelector(`.canvasOfOriginImg`)
    if(!canvasOfOriginImg){
      getImageInfo(url).then((oImg)=>{
        canvasOfOriginImg = document.createElement('canvas')

        canvasOfOriginImg.className = 'canvasOfOriginImg'

        canvasOfOriginImg.scale = scale
        canvasOfOriginImg.render = (type)=>{
          var clipBox = document.querySelector('.clipBox')
          var newWidth = oImg.width * canvasOfOriginImg.scale
          var newHeight = oImg.height * canvasOfOriginImg.scale
          if(type === 'shink'){
            if(clipBox.getBoundingClientRect().width > clipBox.getBoundingClientRect().height){
              if(newWidth < clipBox.getBoundingClientRect().width){
                newWidth = clipBox.getBoundingClientRect().width
                newHeight = newWidth * (oImg.height / oImg.width)
              }
            }else{
              if(newHeight < clipBox.getBoundingClientRect().height){
                newHeight = clipBox.getBoundingClientRect().height
                newWidth = newHeight * (oImg.width / oImg.height)
              }
            }
          }

          var newLeft = parseFloat(canvasOfOriginImg.style.left) - ((newWidth - canvasOfOriginImg.width) / 2 )
          var newTop = parseFloat(canvasOfOriginImg.style.top) - ((newHeight - canvasOfOriginImg.height) / 2 )



          if(type === 'shink'){
            if(newLeft > parseFloat(clipBox.style.left)){
              newLeft = parseFloat(clipBox.style.left)
            }
            var referenceDom = document.querySelector('.referenceDom')
            if(
              (referenceDom.getBoundingClientRect().left + newLeft + newWidth) < (clipBox.getBoundingClientRect().left + clipBox.getBoundingClientRect().width)
            ){
              newLeft += ((clipBox.getBoundingClientRect().left + clipBox.getBoundingClientRect().width) - (referenceDom.getBoundingClientRect().left + newLeft + newWidth))
            }


            if(newTop > parseFloat(clipBox.style.top)){
              newTop = parseFloat(clipBox.style.top)
            }
            if(
              (referenceDom.getBoundingClientRect().top + newTop + newHeight) < (clipBox.getBoundingClientRect().top + clipBox.getBoundingClientRect().height)
            ){
              newTop += ((clipBox.getBoundingClientRect().top + clipBox.getBoundingClientRect().height) - (referenceDom.getBoundingClientRect().top + newTop + newHeight))
            }

          }




          canvasOfOriginImg.style = setStyle({
            left: newLeft,
            top: newTop
          })
          canvasOfOriginImg.width = newWidth
          canvasOfOriginImg.height = newHeight
          canvasOfOriginImg.scale = canvasOfOriginImg.width / oImg.width

          console.log(canvasOfOriginImg.scale)

          var canvasOfOriginImgCtx = canvasOfOriginImg.getContext('2d');
          canvasOfOriginImgCtx.clearRect(0, 0, canvasOfOriginImg.width, canvasOfOriginImg.height);
          canvasOfOriginImgCtx.save();
          canvasOfOriginImgCtx.translate(0, 0);
          canvasOfOriginImgCtx.rotate(0);
          //canvasOfOriginImgCtx.scale(canvasOfOriginImg.scale,canvasOfOriginImg.scale);
          canvasOfOriginImgCtx.drawImage(oImg, 0, 0, canvasOfOriginImg.width, canvasOfOriginImg.height);
          canvasOfOriginImgCtx.restore();
        }
        canvasOfOriginImg.render()


        canvasOfOriginImg = addDragFunction({
          dragedDom: canvasOfOriginImg,
          scaleble: true,
          opacity: 0.3,
          limitFn: ()=>{
            var clipBox = document.querySelector('.clipBox')

            var minLeft = parseFloat(canvasOfOriginImg.style.left) - (
              (canvasOfOriginImg.getBoundingClientRect().left + canvasOfOriginImg.getBoundingClientRect().width) -
              (clipBox.getBoundingClientRect().left + clipBox.getBoundingClientRect().width)
            )
            var minTop = parseFloat(canvasOfOriginImg.style.top) - (
              (canvasOfOriginImg.getBoundingClientRect().top + canvasOfOriginImg.getBoundingClientRect().height) -
              (clipBox.getBoundingClientRect().top + clipBox.getBoundingClientRect().height)
            )
            var maxLeft = parseFloat(clipBox.style.left)
            var maxTop = parseFloat(clipBox.style.top)
            return [
              minLeft,
              minTop,
              maxLeft,
              maxTop
            ]
          }
        })
        resolve(canvasOfOriginImg)
      })

    }else{
      resolve(canvasOfOriginImg)
    }
  })
}


export function clipAndUpload(url, {x, y, width, height}){
  return new Promise((resolve)=>{
    clipImgByUrl(
      url,
      {
        x: x ,
        y: y,
        width,
        height
      }
    ).then((base64)=>{
      var blob = base64ToBlob(base64);
      var file = blobToFile(blob)

      mm.http({
        url: '/api/image/upload',
        method: 'post',
        data: (() => {
          var formData = new FormData()
          formData.append('type', 1)
          formData.append('image[0]', file)
          formData.append('m_image_bank_category_id', 0)
          return formData
        })(),
        headers: {
          'content-type': 'multipart/form-data'
        }
      }).then((res) => {
        if (res.code === 204) {
          resolve(res.data.list[0].url)
        } else {

        }
      })
    })
  })
}


function blobToFile(blob){
  return new File([blob], "converted_image.png", {
    type: blob.type,
    lastModified: new Date().getTime()
  });
}

function base64ToBlob(dataURL) {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function clipImgByUrl(url,{
  x,y,width,height
}){
  return new Promise((resolve)=>{
    getCanvasOfOriginImg(url).then((canvasOfOriginImg)=>{
      var newCanvas = createCanvasByImageData((()=>{
        var canvasOfOriginImgCtx = canvasOfOriginImg.getContext('2d')
        var imageData = canvasOfOriginImgCtx.getImageData(x ,y , width , height )
        return imageData
      })())
      var base64 = newCanvas.toDataURL('image/png')

      resolve(base64)
    })
  })
}


function createCanvasByImageData(imageData){
  const canvas = document.createElement('canvas');
  canvas.width = imageData.width
  canvas.height = imageData.height
  canvas.style="width: "+ imageData.width +"px;height: "+ imageData.height +"px;"
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.putImageData(imageData,0,0)
  return canvas
}

